import './marketing-widget.scss'
import React, { useEffect, useState } from 'react';
import { Col, Card } from 'reactstrap';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { loading, success, RD, SRD, failure } from 'srd';
import { isArray } from 'lodash';
import OnImagesLoaded from 'react-on-images-loaded'
import { DisplayMode } from 'app/modules/cms/model/marketing-campaign-models';
import { LoadingSpinner } from '../loading';
import ContentLoader from 'react-content-loader';

const MarketingWidget = (props: { marketingItems?: any }) => {
  const { marketingItems } = props;
  const [marketingWidgetSRD, setMarketingWidgetSRD] = React.useState<RD<string, any[]>>(loading())
  const [imagesLoaded, setImagesLoaded] = useState(false)
  let rightSideBarContent;

  useEffect(() => {
    if (marketingItems !== undefined) {
      rightSideBarContent = marketingItems[DisplayMode.RIGHT_SIDEBAR];
      if (isArray(rightSideBarContent) && rightSideBarContent.length > 0 && rightSideBarContent !== undefined) {
        setMarketingWidgetSRD(success(rightSideBarContent))
      } else {
        setMarketingWidgetSRD(success(undefined));
      }
    } else {
      setMarketingWidgetSRD(success(undefined))
    }
  }, [marketingItems])

  const MarketingWidgetItem = ({ content }) => {
    return content.map((item, index) => {
      return (
        <Col md={12} key={index} className="noPadding" >
          <Card className="jh-card widget market-shadow">
            <div className="widgetBody">
              {imagesLoaded ?
                <div>
                  <img src={item.iconURL} alt="icon" />
                  <h5>{item.title}</h5>
                  <p>{item.text}</p>
                </div>
                :
                <div><LoadingSpinner /></div>
              }
              {/* <div style={{ display: !imagesLoaded && 'none' }}>
                <img src={item.iconURL} alt="icon" />
                <h5>{item.title}</h5>
                <p>
                  {item.text}
                </p>
              </div>
              <div style={{ display: imagesLoaded && 'none' }}>
                <LoadingSpinner />
              </div> */}
            </div>
          </Card>
        </Col>
      )
    })
  }

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <ContentLoader speed={1} viewBox="0 0 80 90" backgroundColor="#e8e3e3" foregroundColor="#ecebeb">
      <circle cx="27" cy="27" r="18" />
      <rect x="10" y="50" width="50" height="5" />
      <rect x="10" y="60" width="50" height="5" />
    </ContentLoader>,
    failure: (e) => <div></div>,
    success: (content) =>
      <OnImagesLoaded
        onLoaded={() => {
          setImagesLoaded(true)
        }}
      >
        {content && <MarketingWidgetItem content={content} />}
      </OnImagesLoaded>
  }, marketingWidgetSRD)

  return (
    <>
      <div className="desktopWidget">
        {view}
      </div>
    </>
  );
};

export default MarketingWidget;
